import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202402/spring-new-term-plan/index.vue')
const Clazz = () => import('../activity/202402/spring-new-term-plan/MyClazz.vue')
const Record = () => import('../activity/202402/spring-new-term-plan/Record.vue')

export const indexRoute: RouteConfig = {
  path: '/new-term-plan-2024',
  name: 'new_term_plan_2024',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '新学期计划',
    ignoreLogin: true,
  },
}

export const clazzRoute: RouteConfig = {
  path: '/new-term-plan-2024-clazz',
  name: 'new_term_plan_2024_clazz',
  component: Clazz,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '新学期计划',
    ignoreLogin: true,
  },
}

export const recordRoute: RouteConfig = {
  path: '/new-term-plan-2024-record',
  name: 'new_term_plan_2024_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '新学期计划',
    ignoreLogin: true,
  },
}

export default [indexRoute, clazzRoute, recordRoute]

export function navigateToNewTermPlan2024(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
